import { useSelector } from "react-redux";
import { useParams } from "react-router-dom"
import { RootState } from "store";

const OverallCollaboration = () => {

    const { campaignId } = useParams();

    const campaignInsightsData = useSelector((state: RootState) => state.campaignInsights.campaigns[campaignId!]);
    const campaign = useSelector((state: RootState) => state.campaigns.items[campaignId!]);

    const insights = campaignInsightsData?.insights;

    return (
        <div className="card campaign-insights-card mb-0">
            <div className="card-header bg-danger-light px-4">
                <span>Overall Collaboration</span>
            </div>
            <div className="card-body d-flex flex-column gap-3 p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="title">
                        <span className="oval gray"></span>
                        Total Content Posted
                    </div>
                    <div className="value">
                        <span>{insights?.counts?.posts ?? 0}</span>
                    </div>
                </div>
                {
                    campaign?.data?.campaign?.platform === 'ig' &&
                    <>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="title">
                                <span className="oval green"></span>
                                Story Posted
                            </div>
                            <div className="value">
                                <span>{insights?.counts?.media_product_types?.STORY?.count ?? 0}</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="title">
                                <span className="oval red"></span>
                                Post Posted
                            </div>
                            <div className="value">
                                <span>{insights?.counts?.media_product_types?.FEED?.count ?? 0}</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="title">
                                <span className="oval skyblue"></span>
                                Reel Posted
                            </div>
                            <div className="value">
                                <span>{insights?.counts?.media_product_types?.REELS?.count ?? 0}</span>
                            </div>
                        </div>
                    </>
                }
                {
                    campaign?.data?.campaign?.platform === 'yt' &&
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="title">
                            <span className="oval red"></span>
                            Video Posted
                        </div>
                        <div className="value">
                            <span>{insights?.counts?.media_product_types?.VIDEO?.count ?? 0}</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default OverallCollaboration
